(function () {
  const theme = window.MinardiTheme || {};
  const moneyFormatter = new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: theme.currency || "EUR"
  });
  const strings = theme.strings || {};

  const body = document.body;
  const cartShell = document.querySelector("[data-cart-shell]");
  const cartItems = document.querySelector("[data-cart-items]");
  const cartCountNodes = document.querySelectorAll("[data-cart-count]");
  const cartTotal = document.querySelector("[data-cart-total]");

  function formatMoney(cents) {
    return moneyFormatter.format((cents || 0) / 100);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function openCart() {
    if (!cartShell) return;
    cartShell.hidden = false;
    window.requestAnimationFrame(() => body.classList.add("is-cart-open"));
    refreshCart();
  }

  function closeCart() {
    body.classList.remove("is-cart-open");
    window.setTimeout(() => {
      if (cartShell && !body.classList.contains("is-cart-open")) cartShell.hidden = true;
    }, 260);
  }

  function renderCart(cart) {
    cartCountNodes.forEach((node) => {
      node.textContent = cart.item_count;
    });

    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
    if (!cartItems) return;

    if (!cart.items.length) {
      cartItems.innerHTML = `
        <div class="cart-drawer__empty">
          <p>${escapeHtml(strings.cartEmpty || "Il carrello e vuoto.")}</p>
          <a class="luxury-button luxury-button--gold" href="/collections/all">${escapeHtml(strings.cartEmptyCta || "Scopri la collezione")}</a>
        </div>
      `;
      return;
    }

    cartItems.innerHTML = cart.items
      .map((item) => {
        const image = item.image
          ? `<img class="cart-drawer__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}">`
          : `<div class="cart-drawer__image cart-drawer__image--empty"></div>`;

        return `
          <div class="cart-drawer__line" data-line-key="${item.key}">
            ${image}
            <div>
              <a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
              <span>${escapeHtml(item.variant_title || "")}</span>
              <div class="cart-line-controls">
                <button type="button" data-cart-quantity="minus" data-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(strings.decreaseQuantity || "Diminuisci quantita")}">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-quantity="plus" data-key="${escapeHtml(item.key)}" aria-label="${escapeHtml(strings.increaseQuantity || "Aumenta quantita")}">+</button>
                <button type="button" data-cart-remove data-key="${escapeHtml(item.key)}">${escapeHtml(strings.remove || "Rimuovi")}</button>
              </div>
            </div>
            <strong>${formatMoney(item.final_line_price)}</strong>
          </div>
        `;
      })
      .join("");
  }

  async function fetchCart() {
    const response = await fetch("/cart.js", {
      headers: { Accept: "application/json" }
    });
    if (!response.ok) throw new Error("Cart fetch failed");
    return response.json();
  }

  async function refreshCart() {
    if (!cartShell) return;
    try {
      renderCart(await fetchCart());
    } catch (error) {
      console.warn(error);
    }
  }

  async function changeCartLine(key, quantity) {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({ id: key, quantity })
    });

    if (!response.ok) throw new Error("Cart change failed");
    renderCart(await response.json());
  }

  document.querySelectorAll("[data-cart-toggle]").forEach((button) => {
    button.addEventListener("click", openCart);
  });

  document.querySelectorAll("[data-cart-close]").forEach((button) => {
    button.addEventListener("click", closeCart);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeCart();
      body.classList.remove("is-menu-open");
    }
  });

  document.addEventListener("click", async (event) => {
    const quantityButton = event.target.closest("[data-cart-quantity]");
    const removeButton = event.target.closest("[data-cart-remove]");

    if (quantityButton) {
      const line = quantityButton.closest("[data-line-key]");
      const quantityText = line ? line.querySelector(".cart-line-controls span") : null;
      const currentQuantity = quantityText ? Number(quantityText.textContent) : 1;
      const nextQuantity = quantityButton.dataset.cartQuantity === "plus" ? currentQuantity + 1 : Math.max(0, currentQuantity - 1);

      quantityButton.disabled = true;
      try {
        await changeCartLine(quantityButton.dataset.key, nextQuantity);
      } finally {
        quantityButton.disabled = false;
      }
    }

    if (removeButton) {
      removeButton.disabled = true;
      try {
        await changeCartLine(removeButton.dataset.key, 0);
      } finally {
        removeButton.disabled = false;
      }
    }
  });

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      if (!theme.enableAjaxCart) return;
      event.preventDefault();

      const submit = form.querySelector("button[type='submit']");
      if (submit) submit.disabled = true;

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          body: new FormData(form),
          headers: { Accept: "application/json" }
        });

        if (!response.ok) throw new Error("Cart add failed");
        await refreshCart();
        openCart();
      } catch (error) {
        console.warn(error);
        form.submit();
      } finally {
        if (submit) submit.disabled = false;
      }
    });
  });

  document.querySelectorAll("[data-quantity-control]").forEach((control) => {
    const input = control.querySelector("input");
    const minus = control.querySelector("[data-quantity-minus]");
    const plus = control.querySelector("[data-quantity-plus]");

    if (!input) return;

    minus && minus.addEventListener("click", () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    });

    plus && plus.addEventListener("click", () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
    const mainImage = gallery.querySelector(".product-gallery-commerce__main img");
    const thumbs = gallery.querySelectorAll("[data-gallery-thumb]");

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        if (!mainImage || !thumb.dataset.full) return;

        mainImage.style.opacity = "0";
        window.setTimeout(() => {
          mainImage.removeAttribute("srcset");
          mainImage.removeAttribute("sizes");
          mainImage.src = thumb.dataset.full;
          mainImage.alt = thumb.dataset.alt || mainImage.alt;
          mainImage.style.opacity = "1";
        }, 120);

        thumbs.forEach((item) => item.classList.remove("is-active"));
        thumb.classList.add("is-active");
      });
    });
  });

  const menuToggle = document.querySelector("[data-menu-toggle]");
  if (menuToggle) {
    menuToggle.addEventListener("click", () => {
      const isOpen = body.classList.toggle("is-menu-open");
      menuToggle.setAttribute("aria-expanded", String(isOpen));
    });
  }

  document.querySelectorAll("[data-menu-panel] a").forEach((link) => {
    link.addEventListener("click", () => {
      body.classList.remove("is-menu-open");
      if (menuToggle) menuToggle.setAttribute("aria-expanded", "false");
    });
  });

  const parallax = document.querySelector("[data-parallax]");
  if (parallax && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const bottles = parallax.querySelector(".hero-luxury__bottles");
    window.addEventListener("scroll", () => {
      const offset = Math.min(window.scrollY * 0.08, 52);
      if (bottles) bottles.style.transform = `translate3d(0, ${offset}px, 0)`;
    }, { passive: true });
  }

  const revealItems = document.querySelectorAll(".reveal-on-scroll");
  if (revealItems.length) {
    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16 });

      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add("is-visible"));
    }
  }

  refreshCart();
})();
